import { Grid } from "@mui/material";
import React from "react";
import WalletInput from "./WalletInput";
import WalletList from "./WalletList";

function AdvancedTradeWallet({ handleGetWalletInfo }) {
  return (
    <Grid container maxHeight="1020px" overflow="auto" pr={2}>
      {/* <Grid item xs={12} mb={1}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h5" color="text.main">
            Available Balance
          </Typography>

          <PortfolioChartMenu />
        </Box>
      </Grid>

      <Grid item xs={12} mb={1}>
        <SelectValueBalance />
      </Grid> */}

      <Grid item xs={12} mb={1}>
        <WalletInput handleChange={handleGetWalletInfo} />
      </Grid>

      <Grid item xs={12}>
        <WalletList />
      </Grid>
    </Grid>
  );
}

export default AdvancedTradeWallet;
